import { ArrowRight } from "@phosphor-icons/react";
import { Container, Overline, SectionTitle, Flow } from "./Section";

export default function Approche({ t }) {
  const a = t.approche;
  return (
    <section id="approche" className="py-24 lg:py-32 bg-[#F4F5F7]">
      <Container>
        <Overline testid="approche-overline">{a.overline}</Overline>
        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          <SectionTitle testid="approche-title">{a.title}</SectionTitle>
          <p className="text-base md:text-lg leading-relaxed text-[#5A6B7C] lg:pt-2" data-testid="approche-text">{a.text}</p>
        </div>
        <div className="mb-16 pb-10 border-b border-[#D5DBE3]">
          <Flow steps={a.steps.map((s) => s.name)} testid="approche-flow" />
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-6">
          {a.steps.map((step, i) => (
            <div key={step.name} data-testid={`approche-step-${i}`}>
              <div className="flex items-center gap-3 mb-6">
                <span className="font-heading text-xs font-bold tracking-widest text-[#5A6B7C]">0{i + 1}</span>
                <span className="h-px flex-1 bg-[#0B1B3D]" />
                {i < a.steps.length - 1 && <ArrowRight size={14} weight="light" className="text-[#5A6B7C] hidden lg:block" />}
              </div>
              <h3 className="font-heading text-base font-bold tracking-[0.12em] uppercase text-[#0B1B3D] mb-3">{step.name}</h3>
              <p className="text-sm text-[#5A6B7C] leading-relaxed">{step.detail}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
